import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss']
})
export class ForbiddenComponent {
  constructor(private router: Router, public auth: AuthService) {}

  goDashboard() { this.router.navigate(['/dashboard']); }
  logoutAndLogin() { this.auth.logout(); this.router.navigate(['/login']); }
}

